(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["outin-voucher-price"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__oxVp) return;
    window.__oxVp = true;
    var timer;
    function cookie(n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; }
    function fmt(c) { return 'RM' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function currentId() {
      var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = f && f.value;
      if (!id) { try { id = new URL(window.location.href).searchParams.get('variant'); } catch (e) {} }
      return id;
    }
    function paint(el) {
      var list = Number(el.getAttribute('data-list')) || 0;
      var cmp = Number(el.getAttribute('data-compare')) || 0;
      var auto = Number(el.getAttribute('data-auto')) || 0;
      var cp = Number(el.getAttribute('data-code-pct')) || 0;
      var code = (el.getAttribute('data-code') || '').toLowerCase();
      var avail = true;
      if (el.__map === undefined) { try { el.__map = JSON.parse(el.getAttribute('data-variants') || 'null'); } catch (e) { el.__map = null; } }
      if (el.__map) { var v = el.__map[currentId()]; if (v) { list = v.c; cmp = v.m || 0; avail = v.a; } }
      var on = !!code && cookie('discount_code').toLowerCase() === code;
      var pct = (on && cp > auto) ? cp : auto;
      if (!avail) pct = 0;
      var ref = cmp > list ? cmp : list;
      var price = el.querySelector('[data-vp-price]'), was = el.querySelector('[data-vp-was]'), label = el.querySelector('[data-vp-label]'), nudge = el.querySelector('[data-vp-nudge]');
      if (price) price.textContent = fmt(Math.round(list * (100 - pct) / 100));
      if (was) { was.textContent = fmt(ref); was.hidden = !(pct > 0 || ref > list); }
      if (label) { label.hidden = pct <= 0; label.textContent = (on && pct === cp) ? el.getAttribute('data-label-code') : el.getAttribute('data-label-auto'); }
      if (nudge) nudge.hidden = on || !avail;
    }
    function update() { [].forEach.call(document.querySelectorAll('[data-ox-vp]'), paint); }
    function schedule() { clearTimeout(timer); timer = setTimeout(update, 120); setTimeout(update, 600); setTimeout(update, 1500); }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-vp-getcode]');
      if (b) { document.dispatchEvent(new CustomEvent('outin:popup')); return; }
      schedule();
    });
    document.addEventListener('change', schedule);
    document.addEventListener('mino:variant', schedule);
    document.addEventListener('outin:code', schedule);
    document.addEventListener('DOMContentLoaded', schedule);
    window.addEventListener('load', schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('popstate', schedule);
    update();
  })();
  } catch(e) { console.error(e); }
})();

})();
